var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"w-full lg:mt-20 md:mt-20 mt-16 mb-8"},[_c('CareProffessionBanner')],1),_c('div',[_c('ProfessionalsForm')],1),_c('div',{staticClass:"lg:px-40 md:px-40 px-5 lg:mt-12 md:mt-12 mt-6"},[_c('ProfessionalContent')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('DownloadApp'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }